module.exports = __webpack_public_path__ + "img/NotificationIcon.c86003b9.svg";